import styled from 'styled-components';
import { fromMd } from '../../constants';
export const Image = styled.img `
  width: ${o => o.widthMobile}px;

  ${fromMd} {
    width: ${o => o.widthDesktop}px;
  }
`;
//# sourceMappingURL=styles.js.map